import { AlertCard } from './AlertCard';
import { Box, Link } from '@mui/material';
import { getPhoneCountryInfo } from 'pages/CampaignCreation/utils/getPhoneCountryInfo';
import { SMSLearnMoreDrawer } from 'modules/campaigns/components/SMSLearnMoreDrawer';
import { useDrawerV2 } from 'common/drawer/hooks/useDrawerV2';

type Props = {
  twilioPhoneNumber: string | undefined | null;
};

export const SMSAlertCard: React.FC<Props> = ({ twilioPhoneNumber }) => {
  const { openDrawer } = useDrawerV2();

  const { code, name } = getPhoneCountryInfo(twilioPhoneNumber ?? '');

  return (
    <AlertCard
      title={`This account uses a ${name}-based SMS number, +${code}`}
      type="info"
      sx={{
        maxWidth: '700px'
      }}
    >
      <Box>
        Only message numbers with the same country code.{' '}
        <Link
          component="button"
          sx={{ mb: '3px' }}
          onClick={() =>
            openDrawer({
              width: '600px',
              children: <SMSLearnMoreDrawer phoneCountryCode={code} />
            })
          }
        >
          Learn more
        </Link>
      </Box>
    </AlertCard>
  );
};
